import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/AboutSection.css";

const AboutSection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  const videos = [
    {
      title: "Corporate Video",
      label: "COLOMBO DOCKYARD PLC CORPORATE PROFILE",
      url: "https://www.youtube.com/embed/x1gri6myufw",
      thumbnail: "/wp-content/uploads/2019/10/CDL-1-1.jpg",
    },
    {
      title: "Company Overview",
      label: "SHIPBUILDING KDDI CABLE INFINITY - 133M CABLE LAYING VESSEL",
      url: "https://www.youtube.com/embed/G4jglJafOGs",
      thumbnail: "/wp-content/uploads/2019/10/CDL-2.jpg",
    },
    {
      title: "RRARS Service",
      label: "SHIP REPAIRS RAPID RESPONSE AFLOAT REPAIRS (RRARS)",
      url: "https://www.youtube.com/embed/aSueI2s-yPE",
      thumbnail: "/wp-content/uploads/2019/10/CDL-2-1.jpg",
    },
    {
      title: "Shipbuilding",
      label: "SHIPBUILDING EXECUTIVE VALOUR - MULTIPURPOSE PLATFORM SUPPLY VESSEL",
      url: "https://www.youtube.com/embed/MmtxebcxdU0",
      thumbnail: "/wp-content/uploads/2019/10/CDL-4.jpg",
    },
    {
      title: "Damage Hull Repair",
      label: "DAMAGED HULL REPAIR BY COLOMBO DOCKYARD PLC",
      url: "https://www.youtube.com/embed/sb9Cl928PYI",
      thumbnail: "/wp-content/uploads/2019/10/Damadge Hull.jpg",
    },
    {
      title: "MISJE Project",
      label: "MISJE VITA VESSEL AV",
      url: "https://www.youtube.com/embed/6FfL1J1oo3U",
      thumbnail: "/wp-content/uploads/2019/10/MISJE.jpg",
    },
  ];

  const openVideo = (embedUrl) => {
    setCurrentVideoUrl(embedUrl);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentVideoUrl("");
  };

  return (
    <section id="about-cdl">
      <div className="center-container clearfix about-cdl-wrap">
        <div className="about-left" data-aos="fade-right">
          <h1 className="about-title">
            Sri Lanka's Pioneer
            <br />
            Shipbuilding &
            <br />
            Ship Repairing Center
          </h1>

          <div className="about-map">
            <img
              src="/wp-content/themes/cdl/images/map-img.jpg"
              alt="Colombo Dockyard PLC - map"
            />
          </div>

          <h3 className="about-subtitle">
            Strategically Located @ THE HUB OF THE INDIAN OCEAN
          </h3>
        </div>

        <div className="about-right" data-aos="fade-left">
          <div className="about-text">
            <p>
              We are fully equipped to provide an entire gamut of repair services
              ranging from basic to complex requirements. Servicing more than 200
              ships annually, we have proven ourselves capable of handling any type
              of vessel up to 125,000 DWT.
            </p>

            <p>
              Colombo Dockyard has also evolved into a formidable force in
              shipbuilding with four decades of experience.
            </p>

            <Link to="/milestone.html" className="learn-more-home">
              Learn more about our history
            </Link>
          </div>

          <div className="about-video-grid">
            {videos.map((video, index) => (
              <div
                key={index}
                className="about-video-card"
                onClick={() => openVideo(video.url)}
              >
                <img src={video.thumbnail} alt={video.title} />

                <div className="about-video-overlay">
                  <h4>{video.label}</h4>
                </div>

                {/* <div className="about-play-btn"></div> */}
              </div>
            ))}
          </div>
        </div>
      </div>

      {modalOpen && (
        <div className="about-modal" onClick={closeModal}>
          <div className="about-modal-inner" onClick={(e) => e.stopPropagation()}>
            <iframe
              src={`${currentVideoUrl}?autoplay=1&rel=0&enablejsapi=1&origin=${window.location.origin}`}
              title="Video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              width="100%"
              height="100%"
            />

            <button onClick={closeModal}>✕</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutSection;